export default __webpack_public_path__ + "static/garden_design16-10738da4a41ba2d546899e097c10849e.webp";